import Head from 'next/head'
import { useRouter } from 'next/router'
import { FC } from 'react'

type Props = {
  currentPage: number
  totalPages: number
}

const Meta: FC<Props> = ({ totalPages, currentPage }) => {
  const router = useRouter()
  const base = process.env.NEXT_PUBLIC_STAGE === 'production' ? 'https://www.gassan.com' : ''
  const url = `${base}${router.asPath.split('?')[0]}`
  let inner = null
  if (totalPages === 1) {
    // Canonical can be the default from page
    inner = null
  }
  if (currentPage === 1 && totalPages > 1) {
    inner = (
      <>
        <link rel="canonical" href={`${url}`} />
        <link rel="next" href={`${url}?page=2`} />
      </>
    )
  }
  if (currentPage === 2) {
    inner = (
      <>
        <link rel="prev" href={`${url}`} />
        <link rel="canonical" href={`${url}?page=2`} />
        {totalPages > 2 && <link rel="next" href={`${url}?page=3`} />}
      </>
    )
  }
  if (currentPage > 2 && currentPage !== totalPages) {
    inner = (
      <>
        <link rel="prev" href={`${url}?page=${currentPage - 1}`} />
        <link rel="canonical" href={`${url}?page=${currentPage}`} />
        {totalPages > currentPage && <link rel="next" href={`${url}?page=${currentPage + 1}`} />}
      </>
    )
  }
  if (currentPage === totalPages) {
    inner = (
      <>
        <link rel="prev" href={`${url}?page=${currentPage - 1}`} />
        <link rel="canonical" key="canonical" href={`${url}?page=${currentPage}`} />
      </>
    )
  }

  return inner ? <Head>{inner}</Head> : null
}

export default Meta
